import { GetModelsDescriptionByModelIdApiResponse } from "infra/api/generated/api";

import { Flex, Image } from "@chakra-ui/react";

export default function Asset({
  data,
}: {
  data?: GetModelsDescriptionByModelIdApiResponse["description"]["assets"][0];
}) {
  return (
    <Flex w="full" h="256px">
      <Image
        w={"full"}
        h="full"
        borderRadius="lg"
        objectFit={"cover"}
        alt={data?.description}
        src={data?.url}
      />
    </Flex>
  );
}
